<template>
  <div
    class="d-flex flex-column p-0 mt-4 mr-0 input neue-roman"
    :class="{ 
      'mt-0': this.first, 
      'flex-sm-row': !this.is_request && !this.labelTop, 
      'align-items-start': this.labelTop, 
      'align-items-center': !this.labelTop 
    }"
  >
    <div class="d-flex align-items-center" :class="{ 'col-sm-6': !this.is_request && !this.labelTop, 'fsp14 mb8 lh20': this.labelTop }">
      <label
        :for="id"
        class="mt-0 pl-0 pt-0 pb-0"
        :class="{ 'mb-1': this.is_request, 'primary-grey': !labelTop }"
      >
        {{ this.label }}
        <span class="require" v-if="this.require"> *</span>
      </label>
      <Popper v-if="this.hint" :hover="true" :id="id + '_hint'">
        <Icon name="info" size="c16" class="ml4" />
        <template #content>
          <span>{{ this.hint }}</span>
        </template>
      </Popper>
    </div>
    <div class="col-12 input-wrapper mt-0 p-0 gap-2" :class="{ 'col-sm-6': !this.is_request && !this.labelTop }">
      <div class="input-slot-wrap" :class="{ 'verified-input-wrap': this.verification }">
        <InputSimple
          :id="id"
          :invalid="this.invalid"
          :invalidHint="this.invalidHint"
          :autocomplete="this.autocomplete"
          :type="this.type"
          :disabled="this.disabled"
          :placeholder="this.placeholder"
          :success="this.success"
          @blurInput="this.blure"
          @onEnter="this.onEnter"
          :regCheck="this.regCheck"
          :dataValue="this.dataValue"
          @updateParentState="this.setValue"
          :autofocus="this.autofocus"
          :icon="icon"
        >
          <Popper v-if="this.verification" :hover="true" :id="id + '_check'">
            <Icon name="check-green" class="c16" />
            <template #content>
              <span>{{ $t('views.InfoReg.3') }}</span>
            </template>
          </Popper>
        </InputSimple>
      </div>
      <!-- <div v-else-if="this.unvisible || this.vMark" class="mw34"></div> -->
      <div v-if="['jur_apartment', 'fact_apartment', 'work_apartment'].includes(this.id)" class="mw54"></div>
      <Popper
        v-if="this.unvisible && !['jur_apartment', 'fact_apartment', 'work_apartment'].includes(this.id)"
        :hover="true"
        :id="id + '_av'"
      >
        <button
          type="button"
          class="btn btn-outline-grey eye-toggle"
          :disabled="this.is_public == '2'"
          @click="toggleUnvisible"
        >
          <Icon :name="unvisibleValue === '1' ? 'eye' : 'eye-off'" size="c20" />
        </button>
        <template #content>
          <span>{{ $t(unvisibleValue === '1' ? 'views.InfoReg.4' : 'views.InfoReg.5') }}</span>
        </template>
      </Popper>
    </div>
  </div>
</template>

<script>
import InputSimple from "@/components/service/InputSimple";
import Icon from '@/components/icons/Icon';
import Popper from '@/components/service/Popper';

export default {
  components: {
    InputSimple,
    Icon,
    Popper
  },
  data() {
    return {
      value: this.dataValue ? this.dataValue : "",
      unvisibleValue: this.unvisibleDataValue ? this.unvisibleDataValue : "",
      sizeW: this.$store.state.resize.w,
    };
  },
  props: {
    id: [String, Boolean],
    first: {
      type: Boolean,
      default: false,
    },
    label: [String],
    type: [String],
    hint: [String, Boolean],
    dataValue: [String, Boolean, Number],
    require: [Boolean],
    disabled: [String, Boolean],
    regCheck: [Object, Boolean],
    invalid: [Boolean, String],
    invalidHint: [String, Boolean],
    verification: [String, Boolean],
    placeholder: [String, Boolean],
    autofocus: [Boolean],
    success: [Boolean],
    autocomplete: {
      type: [String, Boolean],
      default: "new-password",
    },
    unvisible: [Boolean],
    unvisibleDataValue: [String, Boolean],
    vMark: [Boolean],
    is_public: [Boolean, String],
    is_request: [Boolean],
    icon: {
      type: [String, Boolean],
      default: false
    },
    labelTop: [Boolean]
  },
  methods: {
    setValue(arg) {
      this.$emit("updateParentState", {
        id: arg.id,
        value: arg.value,
      });
    },
    toggleUnvisible() {
      let newValue = this.unvisibleValue === '1' ? '0' : '1';
      this.unvisibleValue = newValue;
      this.$emit("updateParentState", {
        id: this.id,
        unvisible: true,
        value: newValue,
      });
    },
    blure(arg) {
      this.$emit("blurInput", {
        id: arg.id,
        value: arg.value,
      });
    },
    onEnter() {
      this.$emit("onEnter");
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  &-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
  }
}
.input-slot-wrap {
  flex: 1;
  min-width: 0;
}

.verified-input-wrap {
  :deep(.input-container) {
    border-color: $primary-green;
  }

  :deep(.active_fill) {
    fill: $primary-green;
  }
}

</style>
